module.exports = __webpack_public_path__ + "img/website.7d1304cf.png";